import { Injectable } from '@angular/core';
import { CognitoAuth } from 'amazon-cognito-auth-js';
import * as MOMENT from 'moment';
import { HttpClient,HttpResponse } from '@angular/common/http';
import {Subject} from 'rxjs';
import { environment as ENV } from '@src/environments/environment';
import { Router} from '@angular/router';


@Injectable({
  providedIn: 'root'
})
export class AuthService {
  failedTogetAccestokenCount = 0;
  auth: any;
  sessions: any;
  getRefreshTokenAction = false;
  sessionDetasils: any
  sesstionSet = new Subject<any>();
  // currentTime: any = MOMENT().add(5, 'minutes');
  constructor(private router: Router, private http: HttpClient ) {
    this.sessionDetasils = this.initCognitoSDK();
    this.sessionDetasils.userhandler = {
      onSuccess: (result: any) => {
        // console.log('result',result);
        this.sessions = result;
        this.sesstionSet.next(true);
        // this.updateRefreshToken();
        window.location.href = window.location.origin + '/index.html#app/';
      },
      onFailure: (err: any) => {
          localStorage.clear();
          window.location.reload();
        // this.router.navigate(['/auth/login']);
      }
    };
    this.sessionDetasils.useCodeGrantFlow();
    var curUrl: any;
    if (window.location.search) {
        curUrl = window.location.href;
        // console.log('URL',curUrl);
      } else {
        curUrl = window.location.origin + window.location.hash.slice(1);
        // console.log('URL WITH SLICE',curUrl);
      }
    this.auth.parseCognitoWebResponse(curUrl);
  }
  initCognitoSDK() {
    const authData = {
      ClientId : ENV.clientId,
      AppWebDomain : ENV.domainName,
      TokenScopesArray : [],
      RedirectUriSignIn : ENV.redirectSignInUrl,
      RedirectUriSignOut : ENV.redirectSignOutUrl,
      IdentityProvider : '',
      UserPoolId : '',
      AdvancedSecurityDataCollectionFlag : true
    };
    this.auth = new CognitoAuth(authData);
    return this.auth
  }
  login() {
    this.auth.getSession();
  }
  signOut() {
    localStorage.removeItem('userSkillsInfo');
    this.auth.signOut();
  }
  // getSessionTokens() {
  //   if(this.sessions) {
  //     return this.sessions;
  //   }
  // }
  get getIdToken() {
    try {
    var payload: any;
    var tokenobj: any;
    var formatted: any;
    if ( this.isAuthenticated ) {
      payload =this.sessionDetasils.signInUserSession.getIdToken().getJwtToken().split('.')[1];
    } else if( this.sessions ) {
      payload = this.sessions.getIdToken().getJwtToken().split('.')[1];
    }
    tokenobj = JSON.parse(atob(payload));
    formatted = JSON.stringify(tokenobj, undefined, 2);
    return JSON.parse(formatted);
    } catch(e) {
      return false;
    }
  }
  get isAuthenticated() {
    return this.auth.isUserSignedIn();
  }
  get getRefreshToken() {
    if (this.sessions) {
      return this.sessions.getRefreshToken().getToken();
    }
    if (this.isAuthenticated) {
      return this.auth.signInUserSession.getRefreshToken().getToken();
    }
  }
  get accessToken() {
    if ( this.sessions ) {
      return this.sessions.getAccessToken().getJwtToken();
    }
    if ( this.isAuthenticated ) {
      return this.sessionDetasils.signInUserSession.accessToken.getJwtToken();
    }
  }

  sesstionSetFlag() {
    return this.sesstionSet.asObservable();
  }

  updateRefreshToken() {
    // if(!this.isAuthenticated) {
    //   return;
    // }
    // if(!this.getRefreshTokenAction) {
    //     this.getRefreshTokenAction  = true;
    // } else {
    //   return;
    // }

    // console.log('after conditions');
    console.log(this.getIdToken['cognito:username']);
    const diffTime = MOMENT(new Date(this.getIdToken.exp * 1000)).diff(MOMENT().add(10,'minutes'),'minutes');
    // console.log(diffTime);
    setTimeout(()=>{
      let params = {
              "grant_type": "refresh_token",
              "client_id": ENV.clientId,
              "refresh_token": this.getRefreshToken
      };
      this.http.post('https://'+ENV.domainName+'/oauth2/token', null,{headers: {"Content-Type" : "application/x-www-form-urlencoded"},params:params}).subscribe((res: any)=>{
        Object.keys(localStorage).forEach(localStorageKey => {
          this.failedTogetAccestokenCount = 0;
          if(localStorageKey.search(`${this.getIdToken['cognito:username']}.idToken`) > 0) {
            //this.sessionDetasils.signInUserSession.setIdToken(res.id_token);
            this.sessionDetasils.signInUserSession.idToken.setJwtToken(res.id_token);
            localStorage.setItem(`${localStorageKey}`,res.id_token);
          }
          if(localStorageKey.search( `${this.getIdToken['cognito:username']}.accessToken`) > 0) {
            //this.sessionDetasils.signInUserSession.setAccessToken(res.access_token);
            this.sessionDetasils.signInUserSession.accessToken.setJwtToken(res.access_token);
            localStorage.setItem(`${localStorageKey}`,res.access_token);
          }
        });
        // console.log('AJAX',res.id_token);
        // console.log('getID',this.sessionDetasils.signInUserSession.idToken.getJwtToken());
        this.updateRefreshToken();
        this.getRefreshTokenAction  = false;
      },(error) => {
        if(this.failedTogetAccestokenCount > 5) {
          localStorage.clear()
          this.login();
        }
        this.updateRefreshToken();
        this.failedTogetAccestokenCount += 1 
        });
    }, diffTime *60 *1000);
  }
}
